const BellIcon = ({ strokeColor = '#808080' }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" cx="397.55" cy="397.55" r="388.66" fill="#4d4d4d" />
        <circle 
          id="Grey" 
          cx="397.55" 
          cy="397.55" 
          r="372.55" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
        />
        <circle 
          id="White_Inner" 
          cx="397.55" 
          cy="397.55" 
          r="343.4" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
        />
      </g>
      <g id="Shapes">
        <g id="Bell">
          <path 
            fill="#fdfdfd" 
            d="M539.95,346.55c1.96,21.26,4.17,41.62,5.68,62.03,2.12,28.72,12.18,54.26,29.17,77.33,5.27,7.16,10.65,14.33,15.03,22.04,16.32,28.69-.45,57.5-33.27,57.54-30.8.04-61.59.04-92.39.1-.6,0-1.19.46-2.74,1.1-.49,22.7-9.86,41.25-29.39,54.47-12.69,8.59-26.68,11.2-41.42,9.76-30.62-3-51.92-27.51-56.39-65.43h-10.3c-28.48,0-56.96-.02-85.44,0-15.24.01-28.22-4.83-35.32-19.08-6.84-13.73-5.11-27.55,3.38-40.23,6.23-9.3,12.87-18.34,19.52-27.34,17.24-23.35,23.14-50.2,25.78-78.48,2.41-25.83,3.57-52.29,10.35-77.08,10.78-39.45,37.59-67.26,74.99-84.06,6.77-3.04,7.66-5.84,6.69-13.14-3.36-25.17,10.87-56.44,48.82-61.83,27.24-3.87,54.47,17.74,57.78,45.98.91,7.76.89,15.62,1.35,24.38,48.6,20.42,80.05,56.38,88.12,111.94M281.35,420.99c-3.64,24.23-10.22,47.44-24.4,67.82-6.78,9.74-14.57,18.79-21.05,28.71-2.44,3.73-2.44,9.05-3.56,13.64,4.06.84,8.11,2.41,12.17,2.41,103,.13,206,.11,309,.11h13.3c-4.67-9.42-7.69-16.75-11.74-23.45-8.8-14.56-19.63-28.08-26.94-43.32-16.39-34.18-16.01-71.76-17.76-108.46-2.04-42.91-30.52-83.6-72.09-94.75-15.89-4.27-33.26-3.21-49.97-4.25-40.16-2.5-88.76,28.57-98.47,78.11-5.24,26.74-5.74,54.4-8.49,83.42M419.26,565.48h-52.2c-.62,20.32,11.51,33.53,30,33.79,20.11.29,32.65-12.32,32.88-33.79h-10.68M401.41,227.94c2.96.11,5.98-.13,8.87.39,8.93,1.59,11.02-3.01,10.21-10.66-1.47-13.85-11.51-23.73-23.49-23.02-12.92.76-22.03,11.52-22.24,25.28-.12,7.62,2.91,10,10.14,8.91,4.86-.74,9.84-.64,16.51-.9h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default BellIcon;
